import styled from "styled-components";
import Div from "../../../common/ui/widgets/division";

export const TabModalWrapper = styled(Div)`
.tab-modal-container{
    z-index: 8;
    text-align: center;
    position: absolute;
    top: ${(props) => props.theme.top56};
    right: 0;
    width: ${(props) => props.theme.width250};
    height: auto;
    background-color: #333333 !important;
    color: #a7a7a7 !important;
}
li{
    list-style: none;
}

.tab-items{
    display: flex;
    flex-direction: column;
}

.side-nav1 {
    border-top: 1px solid #cccccc;
    color: #a7a7a7;
    font-size: ${(props) => props.theme.font16} !important;
    max-height: fit-content;
    height: auto;
    line-height: ${(props) => props.theme.lineHeight64};
    background: #333333;
    cursor: pointer;
}
.active{
    padding:${(props) => props.theme.height24};
}

.lock-icon{
    width: 15px !important;
    height: auto !important;
}

.tab-items a{
    display: flex;
    justify-content: center;
}

.user-logo-dropdown{
    padding-top: ${(props) => props.theme.padding10};
    height: ${(props) => props.theme.height70};
    font-size: ${(props) => props.theme.font69} !important;
}

.side-nav1:hover{
    color: #ffffff;
}
`;